import React from "react";

const HelperText = ({ text, className="" }) => {
  return text ? (
    <p className={"tw-text-xs tw-text-gray-500 tw-my-1 "+ className}>{text}</p>
  ) : null;
};

export default HelperText;
